module.exports = __webpack_public_path__ + "img/SALA.1a32ac1d.png";